const selectors = {
  authAdproResult: (state) => state.main.authAdproResult,
  currentAd: (state) => state.main.currentAd.data,
  currentFacebookAd: (state) => state.main.currentFacebookAd.data,
  currentDashboardResult: (state) => state.main.currentDashboardResult,
  loginToRdynamicResult: (state) => state.facebook.loginToRdynamicResult,
  getNexusUserInfoResult: (state) => state.main.getNexusUserInfoResult,
  checkAppAvailableResult: (state) => state.main.checkAppAvailableResult,
};

export default selectors;
